import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=0e80e0ce&scoped=true"
import script from "./Screen.vue?vue&type=script&lang=js"
export * from "./Screen.vue?vue&type=script&lang=js"
import style0 from "./Screen.vue?vue&type=style&index=0&id=0e80e0ce&prod&lang=scss&scoped=true"
import style1 from "./Screen.vue?vue&type=style&index=1&id=0e80e0ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e80e0ce",
  null
  
)

export default component.exports